import { API_BASE } from "../config";
import styles from "../assets/styles/components/Header.module.css";
import { Link, useNavigate } from "react-router-dom";
import { FaBars, FaAngleDown, FaCogs, FaSignOutAlt } from "react-icons/fa";
import logo from "../assets/images/admin.ico";
import { useContext } from "react";
import { UserContext } from "../context/userContext";

const Header = ({ onToggleMenuMobile, onToggleMenuDesktop, collapsed }) => {
  const navigate = useNavigate();
  const { user, setUser } = useContext(UserContext);
  const handleLogout = async () => {
    try {
      const res = await fetch(`${API_BASE}/Login/logout`, {
        method: "POST",
        credentials: "include",
      });

      const data = await res.json();

      if (data.status === 0) {
        setUser(null);
        navigate("/acp/Account/Login");

        window.location.reload();
      }
    } catch (err) {}
  };
  return (
    <header className={`${styles.header} ${collapsed ? styles.collapsed : ""}`}>
      <div className={styles.path} onClick={onToggleMenuMobile}>
        <span className={styles.logo}>iLaw</span>
        <span className={styles.dsNoneLogo}>iLaw</span>
        <span
          className={styles.menuMobile}
          onClick={(e) => {
            e.stopPropagation();
            onToggleMenuMobile();
          }}
        >
          <FaBars />
        </span>
      </div>
      <nav>
        <span className={styles.toggleBtn} onClick={onToggleMenuDesktop}>
          <FaBars />
        </span>
        <ul className={styles.account}>
          <li className={styles.imgAccount}>
            <img src={logo} alt="Admin" />
            <span>
              {user?.fullName} <FaAngleDown />
            </span>
            <div className={styles.signOut} onClick={handleLogout}>
              <FaSignOutAlt /> Đăng xuất
            </div>
          </li>
          <li className={styles.setting}>
            <Link to="/acp/Settings/Edit" aria-label="Settings" title="Settings">
              <FaCogs />
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
